import React, { useId } from 'react';
import { SplitDisplayDimensionBySelector as StyledSplitDisplayDimensionBySelector } from './styled';
import { DisplayBy } from '../../../constants/DisplayBy';
import SplitRadioButton from './SplitRadioButton';

interface SplitDisplayDimensionBySelectorProps {
  value?: DisplayBy;
  onChange: (value: DisplayBy) => void;
}

const SplitDisplayDimensionBySelector = ({ value, onChange }: Readonly<SplitDisplayDimensionBySelectorProps>): JSX.Element => {
  const selectedValue = value ?? DisplayBy.Name;
  const groupName = useId();

  return (
    <StyledSplitDisplayDimensionBySelector>
      <div className="selectorLabel">Display Dimension By:</div>
      <div>
        <SplitRadioButton
          value={DisplayBy.Name}
          checked={selectedValue === DisplayBy.Name}
          onChange={() => onChange(DisplayBy.Name)}
          label="Name"
          name={groupName}
        />
        <SplitRadioButton
          value={DisplayBy.Id}
          checked={selectedValue === DisplayBy.Id}
          onChange={() => onChange(DisplayBy.Id)}
          label="ID"
          name={groupName}
        />
        <SplitRadioButton
          value={DisplayBy.Both}
          checked={selectedValue === DisplayBy.Both}
          onChange={() => onChange(DisplayBy.Both)}
          label="Both"
          name={groupName}
        />
      </div>
    </StyledSplitDisplayDimensionBySelector>
  );
};

export default SplitDisplayDimensionBySelector;
